<main class="main" *ngIf="isConfigValid$ | async">
  <div class="main-header">
    <app-srs-nav></app-srs-nav>
  </div>
  <router-outlet></router-outlet>
</main>
